import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=72ed7374&scoped=true"
import script from "./MessageIcon.vue?vue&type=script&lang=js"
export * from "./MessageIcon.vue?vue&type=script&lang=js"
import style0 from "./MessageIcon.vue?vue&type=style&index=0&id=72ed7374&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed7374",
  null
  
)

export default component.exports